<template>
  <div>
    <ul
      class="row list-unstyled margin-bottom-0"
      style="--list-style-type: none; --list-padding-left: 0"
    >
      <li
        v-for="path in savePaths"
        :key="path.key"
        class="column-12 tablet:column-6 margin-bottom-md"
      >
        <component
          :is="path.tag"
          v-bind="path.bindings"
          class="card secondary text-left margin-bottom-0"
          style="text-decoration: none; color: inherit; height: 100%"
          @click="$emit('save-path-click', { key: path.key, secondary: false })"
        >
          <div class="padding-bottom-lg">
            <font-awesome-icon
              :icon="$v7.solid[path.icon]"
              size="2x"
            />
          </div>
          <div>
            <h3 class="h4 size-md margin-bottom-2xs">
              {{ path.label }}
            </h3>
            <p class="size-sm margin-bottom-0">
              {{ path.description }}
            </p>
          </div>
        </component>
      </li>
    </ul>

    <p class="size-sm margin-top-md margin-bottom-0 text-left">
      <a
        :href="pricingFeedbackHref"
        @click="$emit('save-path-click', { key: 'switch_plan', secondary: true })"
      >
        Pricing an issue? Email us
      </a>
    </p>
  </div>
</template>

<script>
  import { FA_KITS_CUSTOM_ICONS_DOCS_URL } from 'app/views/icons/routing'
  import { buildSupportMailto, buildFeedbackMailto } from 'app/utils/cancellationSupportEmail'

  export default {
    name: 'ScreenPathsToStay',

    props: {
      accountEmail: {
        type: String,
        default: ''
      },
      planName: {
        type: String,
        default: ''
      },
      subscriptionEndDate: {
        type: String,
        default: ''
      }
    },

    emits: ['save-path-click'],

    computed: {
      savePaths() {
        return [
          {
            key: 'switch_plan',
            label: 'Switch to a different plan',
            description: 'Maybe a different plan fits your needs better.',
            icon: 'faRightLeft',
            tag: 'router-link',
            bindings: { to: { name: 'plans' } }
          },
          {
            key: 'support_email',
            label: 'Having a technical issue?',
            description: "Tell us what's going wrong and we'll help fix it.",
            icon: 'faHeadset',
            tag: 'a',
            bindings: {
              href: buildSupportMailto({
                accountEmail: this.accountEmail,
                planName: this.planName,
                subscriptionEndDate: this.subscriptionEndDate
              })
            }
          },
          {
            key: 'feedback_email',
            label: 'Missing something specific?',
            description: 'Need an icon, a style, or a feature? Let us know.',
            icon: 'faPencil',
            tag: 'a',
            bindings: {
              href: buildFeedbackMailto({
                topic: 'missing_feature',
                accountEmail: this.accountEmail
              })
            }
          },
          {
            key: 'kits_docs',
            label: 'Prefer a different library?',
            description: 'Kits can host your own icons and other icon libraries!',
            icon: 'faCloudArrowUp',
            tag: 'a',
            bindings: {
              href: FA_KITS_CUSTOM_ICONS_DOCS_URL,
              target: '_blank',
              rel: 'noopener noreferrer'
            }
          }
        ]
      },

      pricingFeedbackHref() {
        return buildFeedbackMailto({
          topic: 'pricing',
          accountEmail: this.accountEmail
        })
      }
    }
  }
</script>
